import {React,createContext,useState} from 'react'
const DataContext = createContext();

export const DataProvider = ({ children }) => {
const [soldPins, setSoldPins] = useState({ NICON: 0, CEI: 0, IEI: 0, CARPEX: 0 })
  return (
    <DataContext.Provider value={{soldPins,setSoldPins}}> {children}  </DataContext.Provider>
  )
}

export default DataContext